import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useLocation, useNavigate } from 'react-router-dom';

import Loader from '../../assets/components/loader';

import Swal from "sweetalert2";

import {
  verifyOtpCognito,
  activateTenantAccount,
  sendNewOtp
} from "../../store/actions";

const ActivateAccount = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const activateInfo = useSelector((state) => state.activateAccount);

  const [userId, setUserId] = useState();
  const [tenantId, setTenantId] = useState();

  const [formFields, setFormField] = useState({
    confirmation_code: "",
    email :"",
    new_password: "",
    new_password1:""
  })

  useEffect(() => {
    const u = new URLSearchParams(location.search);
    if (u.size > 0) {
      const userIdParam = u.get('u');
      const tenantIdParam = u.get('t');
      setUserId(userIdParam.replace("b'", "").replace("'", ""));
      setTenantId(tenantIdParam);
      navigate({
        pathname: location.pathname,
        search: '',
      });
    }
  }, [location])

  const changeInput = (ev) =>{
    setFormField({
      ...formFields,
      [ev.target.name] : ev.target.value
    })
  }

  const sendOtp = (ev) =>{
    ev.preventDefault();
    let data = {
      username: userId,
      password: formFields.confirmation_code
    }
    dispatch(verifyOtpCognito(data));
  }

  const reSendOTP = (ev) => {
    ev.preventDefault();
    let data = { username: userId }
    dispatch(sendNewOtp(data));
  }

  const updatePassword = (ev) => {
    ev.preventDefault();
    Swal.fire({
      icon: 'warning',
      title: 'Creating Virtual Space',
      html: `This process may take a few minutes.`,
      confirmButtonText: "Ok",
      showConfirmButton: true,
      showCancelButton: false,
      didOpen() {
        let confirmButtons = document.getElementsByClassName("swal2-confirm")[0]
        confirmButtons.style.backgroundColor = "#611C35";
        confirmButtons.style.color = "#ffffff";
        confirmButtons.style.border = "#611C35";
        confirmButtons.style.boxShadow = "none";
        confirmButtons.style.boxShadow = "none";
        confirmButtons.style.boxShadow = "none";
      }
    }).then((result) => {
      if (result.isConfirmed) {
        return true;
      }
    })
    formFields.username = userId
    formFields.tenant = tenantId
    dispatch(activateTenantAccount(formFields));
  }

  function passwordFeedback(password) {
    if (password !== "" && password.length < 12) {
      return `Password must be at least 12 characters long`
    } else if (password !== "" && !password.match(/[A-Z]/g)) {
      return `Password must contain at least one uppercase character`
    } else if (password !== "" && !password.match(/[^\w\s]/g)) {
      return `Password must contain at least one special character`
    } else if (password !== "" && !password.match(/[0-9]/g)) {
      return `Password must contain at least one number`
    } else {
      return ``
    }
  }

  function disabledResetButton(password, password1, email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (password !== "" && password === password1 &&
      password.match(/[0-9]/g) &&
      password.match(/[^\w\s]/g) &&
      password.match(/[A-Z]/g) &&
      password.length >= 12 &&
      emailRegex.test(email)) {
      return false
    } else {
      return true
    }
  }

  if (activateInfo.activationDone){
    return(
      <>
        <div className="activate--account" style={{ background: "#FFFFFF", minHeight: "100vh" }}>
          <div>
            <div className="activate-top-bar">
              <h1>Activate my account</h1>
            </div>
            <div className="activate-second-bar">
              <h2>{`${tenantId}`}</h2>
              <span>2876905-1</span>
            </div>
            <div className='role--verification'>
              <div>
                <div>
                  <svg width="90" height="90" viewBox="0 0 115 115" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M98.2727 16.7273C87.2954 5.75 72.6591 0 57.5 0C42.3409 0 27.7045 5.75 16.7273 16.7273C5.75 27.7045 0 42.3409 0 57.5C0 72.6591 5.75 87.2954 16.7273 98.2727C27.7045 109.25 42.3409 115 57.5 115C72.6591 115 87.2954 109.25 98.2727 98.2727C109.25 87.2954 115 72.6591 115 57.5C115 42.3409 109.25 27.7045 98.2727 16.7273ZM90.9545 90.9545C82.0682 99.8409 70.0455 104.545 57.5 104.545C44.9545 104.545 32.9318 99.8409 24.0455 90.9545C15.1591 82.0682 10.4545 70.0455 10.4545 57.5C10.4545 44.9545 15.1591 32.9318 24.0455 24.0455C32.9318 15.1591 44.9545 10.4545 57.5 10.4545C70.0455 10.4545 82.0682 15.1591 90.9545 24.0455C99.8409 32.9318 104.545 44.9545 104.545 57.5C104.545 70.0455 99.8409 82.0682 90.9545 90.9545ZM79.9773 38.1591L52.2727 65.8636L40.25 53.8409C38.1591 51.75 35.0227 51.75 32.9318 53.8409C30.8409 55.9318 30.8409 59.0682 32.9318 61.1591L48.6136 76.8409C49.6591 77.8864 51.2273 78.4091 52.2727 78.4091C53.3182 78.4091 54.8864 77.8864 55.9318 76.8409L87.2955 45.4773C89.3864 43.3864 89.3864 40.25 87.2955 38.1591C85.2045 36.0682 82.0682 36.0682 79.9773 38.1591Z" fill="#3e884f" />
                  </svg>
                </div>
                <h2>
                  Thank you for activating your Marquet account.
                </h2>
              </div>
              <div>
                <div className="paragraph">
                  <p>
                    Two accounts have been created:
                  </p>
                  <p>
                    <b>1. Marquet Owner:</b> This is the user associated with the subscription purchase and owner of the Marquet account.
                  </p>
                  <p>
                    <b>2. Marquet Tenant administrator</b>: This is the user to log in to your virtual space as a global administrator.
                  </p>
                  <p>
                    <b>KEEP IN MIND:</b> If you change the password on any of these accounts they will not be automatically synchronized.
                  </p>
                  <p>
                    <b>Finally!</b> Click on "Go to your virtual space" and log in with the email and password created to start designing your virtual shopping events.
                  </p>
                </div>
                <button onClick={ev => { process.env.REACT_APP_URL_DOMAIN_NAME === `app` ? window.open(`https://${tenantId}.marquet.app/administrator`, '_blank') : window.open(`https://${tenantId}.marquet.dev/administrator`, '_blank')}} className='role--verification--btn'>
                  Go to your virtual space
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return(
    <>
      <div className="activate--account" style={{ background: "#FFFFFF", minHeight: "100vh" }}>
        <div>
          <div className="activate-top-bar">
            <h1>Activate my account</h1>
          </div>
          <div className="activate-second-bar">
            <h2>{`${tenantId}`}</h2>
            <span>2876905-1</span>
          </div>
          {activateInfo.otpChecked === false && <div className="activate-main">
            <div className="paragraph">
              <p>
                Thank you for registering an account.
                <b> Check your email and enter your verification code.</b>
                <span> If you did not receive it, please check your spam and junk folder.</span>
              </p>
            </div>
            <form>
              <div className="form-title">
                <h3>VERIFY MY OTP</h3>
              </div>
              <div className="form-input">
                <div className="input--box">
                  <input type="text" name="confirmation_code" value={formFields.confirmation_code} placeholder="Enter your OTP to create your account" onChange={ev => changeInput(ev)} required />
                </div>
              </div>
              <div className="form-buttons">
                <button className="button btn activate-secondary" type="submit" onClick={ev => reSendOTP(ev)} disabled={activateInfo.loading ? true : false}>
                  Resend my verification code
                  {activateInfo.reSendButtonLoading && <Loader size="xs" />}
                </button>
                <button className="button btn activate-primary" type="submit" onClick={ev => sendOtp(ev)} disabled={activateInfo.loading ? true : false}>
                  Verify
                  {activateInfo.verifyButtonLoading && <Loader size="xs" />}
                </button>
              </div>
            </form>
          </div>
          }
          {activateInfo.otpChecked === true && <div className="activate-main">
            <form>
              <div className="form-input">
                <div className="input--box">
                  <label>Confirm your email</label>
                  <input type="email" name="email" value={formFields.email} placeholder="Enter your email" onChange={ev => changeInput(ev)} required />
                </div>
              </div>
              <div className="form-input">
                <div className="input--box">
                  <label>Create your password</label>
                  <input type="password" name="new_password" value={formFields.new_password} placeholder="Enter new password" onChange={ev => changeInput(ev)} required />
                  {passwordFeedback(formFields.new_password) !== "" ?
                    <div className="invalid--feedback">
                      {passwordFeedback(formFields.new_password)}
                    </div> : null
                  }
                </div>
                <div className="input--box">
                  <label>Confirmation password</label>
                  <input type="password" name="new_password1" value={formFields.new_password1} placeholder="Confirm your password" onChange={ev => changeInput(ev)} required />
                  {(formFields.new_password !== "" && formFields.new_password !== formFields.new_password1) ?
                    <div className="invalid--feedback">
                      Passwords does not match
                    </div> : null
                  }
                </div>
                <div className="password-steps">
                  <div className="pass-description">
                    <p>
                      For your security your password must be at least 12 characters long,
                      contain at least 1 number, 1 uppercase letter and one special character.
                    </p>
                  </div>
                  <div className="pass-features">
                    <div className="pass-lock">
                      <svg width="33" height="36" viewBox="0 0 33 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.4541 0.770021C14.3292 0.644882 14.181 0.545598 14.0177 0.477856C13.8545 0.410113 13.6794 0.375244 13.5027 0.375244C13.3259 0.375244 13.1509 0.410113 12.9877 0.477856C12.8244 0.545598 12.6761 0.644882 12.5513 0.770021C9.21075 4.10521 5.51813 5.74996 1.40625 5.74996C1.04987 5.74996 0.708078 5.89153 0.456076 6.14353C0.204074 6.39554 0.0625 6.73732 0.0625 7.09371V15.1589C0.0625 23.0145 3.70138 28.5856 10.8125 31.6897V21.875C10.8122 20.6831 11.208 19.525 11.9378 18.5826C12.6675 17.6403 13.6897 16.9672 14.8438 16.6693V16.5C14.8433 15.0845 15.2155 13.6938 15.923 12.4678C16.6304 11.2418 17.6482 10.2237 18.8739 9.51577C20.0997 8.80784 21.4902 8.43509 22.9056 8.43498C24.3211 8.43487 25.7117 8.80741 26.9375 9.51515V7.09371C26.9375 6.73732 26.7959 6.39554 26.5439 6.14353C26.2919 5.89153 25.9501 5.74996 25.5938 5.74996C21.4792 5.74996 17.7866 4.11058 14.4541 0.770021ZM17.5312 19.1875V16.5C17.5312 15.0744 18.0975 13.7073 19.1056 12.6993C20.1136 11.6913 21.4807 11.125 22.9062 11.125C24.3318 11.125 25.6989 11.6913 26.7069 12.6993C27.715 13.7073 28.2812 15.0744 28.2812 16.5V19.1875H29.625C30.3378 19.1875 31.0213 19.4706 31.5253 19.9746C32.0294 20.4786 32.3125 21.1622 32.3125 21.875V32.625C32.3125 33.3377 32.0294 34.0213 31.5253 34.5253C31.0213 35.0293 30.3378 35.3125 29.625 35.3125H16.1875C15.4747 35.3125 14.7912 35.0293 14.2872 34.5253C13.7831 34.0213 13.5 33.3377 13.5 32.625V21.875C13.5 21.1622 13.7831 20.4786 14.2872 19.9746C14.7912 19.4706 15.4747 19.1875 16.1875 19.1875H17.5312ZM20.2188 16.5V19.1875H25.5938V16.5C25.5938 15.7872 25.3106 15.1036 24.8066 14.5996C24.3026 14.0956 23.619 13.8125 22.9062 13.8125C22.1935 13.8125 21.5099 14.0956 21.0059 14.5996C20.5019 15.1036 20.2188 15.7872 20.2188 16.5ZM24.9219 27.25C24.9219 26.7154 24.7095 26.2027 24.3315 25.8247C23.9535 25.4467 23.4408 25.2343 22.9062 25.2343C22.3717 25.2343 21.859 25.4467 21.481 25.8247C21.103 26.2027 20.8906 26.7154 20.8906 27.25C20.8906 27.7845 21.103 28.2972 21.481 28.6752C21.859 29.0532 22.3717 29.2656 22.9062 29.2656C23.4408 29.2656 23.9535 29.0532 24.3315 28.6752C24.7095 28.2972 24.9219 27.7845 24.9219 27.25Z" fill="#545454" />
                      </svg>
                    </div>
                    <div className="pass-list">
                      <ul>
                        <li>
                          <div>
                            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.86643 10C4.75259 9.99963 4.64003 9.97586 4.53576 9.93015C4.43149 9.88444 4.33773 9.81778 4.26032 9.7343L0.225063 5.44166C0.0742197 5.28091 -0.00658653 5.06682 0.000420476 4.84648C0.00742748 4.62615 0.101674 4.41763 0.262426 4.26679C0.423179 4.11594 0.63727 4.03514 0.857601 4.04214C1.07793 4.04915 1.28646 4.1434 1.4373 4.30415L4.85813 7.94916L11.8409 0.310412C11.9118 0.22217 12 0.149346 12.1 0.0964136C12.2 0.043481 12.3098 0.0115572 12.4226 0.00260293C12.5355 -0.0063513 12.6489 0.00785317 12.756 0.0443437C12.8632 0.0808342 12.9617 0.13884 13.0456 0.2148C13.1295 0.290759 13.197 0.383067 13.2439 0.486056C13.2908 0.589044 13.3162 0.700538 13.3185 0.813688C13.3207 0.926839 13.2998 1.03926 13.2571 1.14404C13.2143 1.24882 13.1506 1.34376 13.0698 1.42301L5.48085 9.726C5.40417 9.81099 5.31074 9.8792 5.20643 9.92635C5.10213 9.9735 4.9892 9.99858 4.87474 10H4.86643Z" fill={formFields.new_password.length >= 12 ? "#3e884f" : "#B5B2B2"} />
                            </svg>
                            <span>At least 12 characters long</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.86643 10C4.75259 9.99963 4.64003 9.97586 4.53576 9.93015C4.43149 9.88444 4.33773 9.81778 4.26032 9.7343L0.225063 5.44166C0.0742197 5.28091 -0.00658653 5.06682 0.000420476 4.84648C0.00742748 4.62615 0.101674 4.41763 0.262426 4.26679C0.423179 4.11594 0.63727 4.03514 0.857601 4.04214C1.07793 4.04915 1.28646 4.1434 1.4373 4.30415L4.85813 7.94916L11.8409 0.310412C11.9118 0.22217 12 0.149346 12.1 0.0964136C12.2 0.043481 12.3098 0.0115572 12.4226 0.00260293C12.5355 -0.0063513 12.6489 0.00785317 12.756 0.0443437C12.8632 0.0808342 12.9617 0.13884 13.0456 0.2148C13.1295 0.290759 13.197 0.383067 13.2439 0.486056C13.2908 0.589044 13.3162 0.700538 13.3185 0.813688C13.3207 0.926839 13.2998 1.03926 13.2571 1.14404C13.2143 1.24882 13.1506 1.34376 13.0698 1.42301L5.48085 9.726C5.40417 9.81099 5.31074 9.8792 5.20643 9.92635C5.10213 9.9735 4.9892 9.99858 4.87474 10H4.86643Z" fill={formFields.new_password.match(/[A-Z]/g) ? "#3e884f" : "#B5B2B2"} />
                            </svg>
                            <span>Must contain at least one uppercase character</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.86643 10C4.75259 9.99963 4.64003 9.97586 4.53576 9.93015C4.43149 9.88444 4.33773 9.81778 4.26032 9.7343L0.225063 5.44166C0.0742197 5.28091 -0.00658653 5.06682 0.000420476 4.84648C0.00742748 4.62615 0.101674 4.41763 0.262426 4.26679C0.423179 4.11594 0.63727 4.03514 0.857601 4.04214C1.07793 4.04915 1.28646 4.1434 1.4373 4.30415L4.85813 7.94916L11.8409 0.310412C11.9118 0.22217 12 0.149346 12.1 0.0964136C12.2 0.043481 12.3098 0.0115572 12.4226 0.00260293C12.5355 -0.0063513 12.6489 0.00785317 12.756 0.0443437C12.8632 0.0808342 12.9617 0.13884 13.0456 0.2148C13.1295 0.290759 13.197 0.383067 13.2439 0.486056C13.2908 0.589044 13.3162 0.700538 13.3185 0.813688C13.3207 0.926839 13.2998 1.03926 13.2571 1.14404C13.2143 1.24882 13.1506 1.34376 13.0698 1.42301L5.48085 9.726C5.40417 9.81099 5.31074 9.8792 5.20643 9.92635C5.10213 9.9735 4.9892 9.99858 4.87474 10H4.86643Z" fill={formFields.new_password.match(/[^\w\s]/g) ? "#3e884f" : "#B5B2B2"} />
                            </svg>
                            <span>Must contain at least one special character</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.86643 10C4.75259 9.99963 4.64003 9.97586 4.53576 9.93015C4.43149 9.88444 4.33773 9.81778 4.26032 9.7343L0.225063 5.44166C0.0742197 5.28091 -0.00658653 5.06682 0.000420476 4.84648C0.00742748 4.62615 0.101674 4.41763 0.262426 4.26679C0.423179 4.11594 0.63727 4.03514 0.857601 4.04214C1.07793 4.04915 1.28646 4.1434 1.4373 4.30415L4.85813 7.94916L11.8409 0.310412C11.9118 0.22217 12 0.149346 12.1 0.0964136C12.2 0.043481 12.3098 0.0115572 12.4226 0.00260293C12.5355 -0.0063513 12.6489 0.00785317 12.756 0.0443437C12.8632 0.0808342 12.9617 0.13884 13.0456 0.2148C13.1295 0.290759 13.197 0.383067 13.2439 0.486056C13.2908 0.589044 13.3162 0.700538 13.3185 0.813688C13.3207 0.926839 13.2998 1.03926 13.2571 1.14404C13.2143 1.24882 13.1506 1.34376 13.0698 1.42301L5.48085 9.726C5.40417 9.81099 5.31074 9.8792 5.20643 9.92635C5.10213 9.9735 4.9892 9.99858 4.87474 10H4.86643Z" fill={formFields.new_password.match(/[0-9]/g) ? "#3e884f" : "#B5B2B2"} />
                            </svg>
                            <span>Must contain at least one number</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button className="button btn activate-primary"
                  type="submit"
                  onClick={ev => updatePassword(ev)}
                  disabled={disabledResetButton(formFields.new_password, formFields.new_password1, formFields.email)}>
                  Create My Password
                  {activateInfo.passwordButtonLoading && <Loader size="xs" />}
                </button>
              </div>
            </form>
          </div>
          }
        </div>
      </div>
    </>
  )
}

export default ActivateAccount;